

import * as RS from 'redux-saga';
import { AxiosResponse } from 'axios';
import { AppAction, keepLocal } from '../..';
import { UserService } from './User.Service';
import { setUserDetailsAction, getUserDetailsFailedAction, WEB_GET_USER_DETAILS, WEB_GET_USER_PORTAL_DETAILS, setUserDetailsPortalAction, WEB_SET_USER_FAVORITE, webSetUserFavoriteSuccessAction, webSetUserFavoriteFailedAction, WEB_REMOVE_USER_FAVORITE, WEB_SET_USER_TOPICS, WEB_SET_USER_TOPICS_SUCCEEDED, webSetUserTopicsSuccessAction, WEB_GET_REFRESH_USER_TOKEN, setUserTokenAction} from './User.Actions';
import { IUserColumns, IUserPortalDetails } from './User';


// This is getting the person details for the user. 
function* fetchUserDetails(){
    try{
        let responseData: AxiosResponse<IUserColumns>;        
            if(!keepLocal){
                responseData = yield RS.effects.call(UserService.getUserDetails);
            }
            else{
                responseData = yield RS.effects.call(UserService.getLocalUserDetails);
            }

            yield RS.effects.put(setUserDetailsAction(responseData.data))  
    } catch (error) {
        yield RS.effects.put(getUserDetailsFailedAction(error.message));
    }
}

function* fetchUserPortalDetails(){
    try{
        let responseData: AxiosResponse<IUserPortalDetails>;
        if(!keepLocal){
            responseData = yield RS.effects.call(UserService.getUserPortalDetails);
        }
        else{
            responseData = yield RS.effects.call(UserService.getLocalUserPoratlDetails);
        }
            
            yield RS.effects.put(setUserDetailsPortalAction(responseData.data))
    } catch (error) {
        yield RS.effects.put(getUserDetailsFailedAction(error.message));
    }
}

function* postUserFavoriteCourse(action: AppAction<any>){
    try{
            
            if (action.payload !== undefined){
            let responseData: AxiosResponse<string>;
            responseData = yield RS.effects.call(UserService.setUserFavoriteCourse, action.payload);
            yield fetchUserPortalDetails()
            }
    } catch (error) {
        yield RS.effects.put(webSetUserFavoriteFailedAction(error.message));
    }
}
function* postRemoveUserFavoriteCourse(action: AppAction<any>){
    try{
        
            if (action.payload !== undefined){
            yield RS.effects.call(UserService.removeUserFavoriteCourse, action.payload);
            yield fetchUserPortalDetails()
            }
    } catch (error) {
        yield RS.effects.put(webSetUserFavoriteFailedAction(error.message));
    }
}

function* postUserTopics(action: AppAction<any>){
    try{       
            if (action.payload !== undefined){
            yield RS.effects.call(UserService.setUserTopics, action.payload);
            yield RS.effects.put(webSetUserTopicsSuccessAction())
            yield fetchUserPortalDetails()
            }
    } catch (error) {
        yield RS.effects.put(getUserDetailsFailedAction(error.message));
    }
}
function* getRefreshUserToken(action: AppAction<any>){    
    try{
        let responseData: AxiosResponse<string>;
        responseData = yield RS.effects.call(UserService.getRefreshUserToken);        
        yield RS.effects.put(setUserTokenAction(responseData.data))
        
} catch (error) {
    yield RS.effects.put(webSetUserFavoriteFailedAction(error.message));
}
}

// // This is getting the person details for the user. 
export function* GetUserDetails(){
    yield RS.effects.takeLatest(WEB_GET_USER_DETAILS, fetchUserDetails)
}


export function* GetUserPortalDetails(){
    yield RS.effects.takeLatest(WEB_GET_USER_PORTAL_DETAILS, fetchUserPortalDetails)
}

export function* SetUserFavoriteCourse(){
    yield RS.effects.takeLatest(WEB_SET_USER_FAVORITE, postUserFavoriteCourse)
}
export function* RemoveUserFavoriteCourse(){
    yield RS.effects.takeLatest(WEB_REMOVE_USER_FAVORITE, postRemoveUserFavoriteCourse)
}

export function* SetUserTopics(){
    yield RS.effects.takeLatest(WEB_SET_USER_TOPICS, postUserTopics)
}

export function* GetRefreshUserToken(){
    yield RS.effects.takeLatest(WEB_GET_REFRESH_USER_TOKEN, getRefreshUserToken )
}


// WEBPACK FOOTER //
// ./src/Entities/User/User.Saga.ts